<template>
    <div class="card__footer">
      <slot />
    </div>
</template>

<script>



export default {
  name: 's-card-footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
